<template>
  <transition
    enter-active-class="animated fadeIn"
    leave-active-class="animated fadeOut"
    tag="div"
  >
    <div class="privacy-modal-wrap" v-if="privacyState">
      <div class="privacy-policy">
        <p class="title">{{ title }}</p>
        <div class="privacy-content" v-html="$xss(content)"></div>
        <button class="bottom-btn" @click="userAgree">
          {{ buttonText || $t("public.know") }}
        </button>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  data() {
    return {
      title: "",
      content: "",
      privacyState: false,
      buttonText: null,
    };
  },
  methods: {
    userAgree() {
      this.privacyState = false;
      this.agreeBack();
    },
    agreeBack() {
      // console.log(2222)
    },
  },
};
</script>
<style lang="less" scoped>
@import "~@/assets/sass/color.less";
.animated {
  animation-duration: 0.3s;
}
.privacy-modal-wrap {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 99999;
}
.privacy-policy {
  width: 90%;
  .absolutely-centered;
  background: white;
  border-radius: 0.15rem;
  overflow: hidden;
  height: 85%;
  .title {
    font-size: 0.3rem;
    line-height: 0.8rem;
    text-align: center;
    color: #333;
    background: #f6f6f6;
  }
  .privacy-content {
    padding: 0 5%;
    height: calc(100% - 2.7rem);
    margin: 0.4rem 0;
    overflow-y: auto;
    /deep/ h1,
    /deep/ h2,
    /deep/ h3,
    /deep/ h4,
    /deep/ h5,
    /deep/ h6 {
      margin: 0;
      padding: 0;
      padding-top: 0.58rem !important;
      font-weight: bold;
      line-height: 0.58rem !important;
    }
    /deep/ h1 {
      font-size: 0.49rem !important;
    }
    /deep/ h2 {
      font-size: 0.45rem !important;
    }
    /deep/ h3 {
      font-size: 0.42rem !important;
      text-align: left;
      background-color: #fff;
    }
    /deep/ h4 {
      font-size: 0.4rem !important;
    }

    /deep/ h5 {
      font-size: 0.38rem !important;
    }

    /deep/ p {
      //
      margin: 0 !important;
      font-size: 0.28rem !important;
      line-height: 0.58rem !important;
      padding-top: 0rem !important;
      text-align: justify;
    }

    /deep/ img {
      display: block;
      margin: 0 auto;
      padding: 0.58rem 0 0.58rem 0;
      max-width: 100%;
    }
    /deep/ ol,
    /deep/ ol > li {
      list-style-type: decimal;
      list-style: decimal;
    }
    /deep/ ul {
      margin-block-start: 0.48em;
      margin-block-end: 0.48em;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
      padding-left: 0.53rem;
    }

    /deep/ ul > li {
      list-style: disc;
    }
    /deep/ ul > li,
    /deep/ ol > li {
      font-size: 0.34rem;
      line-height: 0.58rem;
      padding-top: 0.38rem;
    }
    /deep/ ol {
      margin-block-start: 0.48rem;
      margin-block-end: 0.48rem;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
      padding-left: 0.53rem;
    }

    /deep/ .table-container {
      width: 100%;
      overflow: auto;
    }

    /deep/ table {
      width: 100%;
      border-right: 0.02rem solid #d9ddde;
      border-bottom: 0.02rem solid #d9ddde;
      border-collapse: collapse;
      margin-top: 0.29rem;
      /deep/ thead {
        background: #eee;
      }
      /deep/ tr td {
        border-left: 0.02rem solid #d9ddde;
        border-top: 0.02rem solid #d9ddde;
        line-height: 0.58rem;
        font-size: 0.32rem;
      }
      /deep/ td {
        padding: 0 0.05rem;
      }
    }

    /deep/ a {
      font-size: 0.34rem;
      line-height: 0.34rem;
      padding-top: 0.29rem;
      color: #005587;
    }

    /deep/ blockquote {
      font-size: 0.34rem;
      line-height: 0.58rem;
      margin: 0;
      padding: 0;
      padding: 0.29rem 0.38rem;
      margin-top: 0.38rem;
      /* width: 100%; */
      min-height: 1.02rem;
      position: relative;
      background: #f6f6f6;
      border-radius: 6px;
      /deep/ p {
        margin: 0;
        padding: 0;
        font-size: 0.34rem;
        line-height: 0.34rem;
      }
      &:after {
        position: absolute;
        left: 0.195rem;
        top: 0.195rem;
        content: "";
        display: block;
        width: 0.24rem;
        height: 0.24rem;
        background: url("~@/assets/img/yinyong.png") no-repeat center/contain;
        transform: rotate(180deg);
      }
      &:before {
        position: absolute;
        right: 0.195rem;
        bottom: 0.195rem;
        content: "";
        display: block;
        width: 0.24rem;
        height: 0.24rem;
        background: url("~@/assets/img/yinyong.png") no-repeat center/contain;
      }
    }
  }
  .bottom-btn {
    outline: none;
    border: none;
    background: @mColor;
    color: white;
    line-height: 0.78rem;
    display: block;
    border-radius: 0.39rem;
    padding: 0 0.3rem;
    font-size: 0.3rem;
    margin: 0 auto;
  }
}
</style>
